import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import ParticleBackground from './ParticleBackground'
import ScrollToTop from './ScrollToTop'

export default function Layout() {
  return (
    <div className="relative min-h-screen bg-martimma-dark">
      <ParticleBackground />
      <div className="relative z-10">
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </div>
  )
}
